import { SettingsOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { themeColors } from 'colors';

const SettingsHeader = () => (
    <Stack direction="row" alignItems="start" columnGap={1} width="100%">
        <Typography variant="body1" color={themeColors.action.active} mt={0.5}>
            <SettingsOutlined fontSize="inherit" />
        </Typography>

        <Typography color={themeColors.action.active} variant="body1" whiteSpace="nowrap">
            settings
        </Typography>
    </Stack>
);

export default SettingsHeader;
